import React from 'react';
import cn from 'classnames';
import BookDemoButton from '@/dataroom/ui/common/BookDemoButton';
import baseStyles from '@/dataroom/ui/components/Landing/researchRoom/tenantResearchRoomStyles.module.scss';
import styles from './startActions.module.scss';

const StartActions = () => (
  <div className={ styles.actionsWrp }>
    <BookDemoButton className={ cn(baseStyles.actionButton, styles.bookDemoButton) } />
  </div>
);

export default StartActions;
